import { NotificationRepository } from "@core/data/repositories/notification.repository";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class GetUnreadNotificationCountUseCase {
    constructor(
        @inject(NotificationRepository)
        private readonly repository: NotificationRepository,
    ) {}

    execute(): Promise<Either<FallbackError, number>> {
        return this.repository.fetchUnreadCount();
    }
}
